import { Autocomplete, AutocompleteProps, TextField } from "@mui/material";
import { capitalize } from "lodash";
import { useTranslation } from "react-i18next";
import { GetTrailersQuery } from "../../../graphql/generated";
import activeOrSelected from "../../../utils/assets/activeOrSelected";

export type TrailerSelectProps = {
  trailers: GetTrailersQuery["trailers"]["data"];
  onChange: (
    trailer: GetTrailersQuery["trailers"]["data"][0] | null | undefined
  ) => void;
  "data-testid"?: string;
} & Omit<
  AutocompleteProps<
    GetTrailersQuery["trailers"]["data"][0],
    undefined,
    undefined,
    undefined
  >,
  | "options"
  | "disablePortal"
  | "filterOptions"
  | "getOptionLabel"
  | "size"
  | "renderInput"
  | "onChange"
>;

export default function TrailerSelect({
  trailers,
  onChange,
  "data-testid": dataTestId,
  ...props
}: TrailerSelectProps) {
  const { t } = useTranslation(["assets"]);
  const selectableTrailers = activeOrSelected(
    trailers || [],
    [props.value?._id]
  );
  return (
    <Autocomplete
      data-testid={dataTestId}
      disablePortal
      fullWidth
      options={selectableTrailers}
      getOptionLabel={(option) => option.serialNumber}
      renderOption={(props, option) => (
        <li
          {...props}
          data-testid={
            dataTestId ? `${dataTestId}-option-${option._id}` : undefined
          }
        >
          {option.serialNumber}
        </li>
      )}
      onChange={(e, trailer) => {
        onChange(trailer);
      }}
      value={props.value}
      size="small"
      renderInput={(inputProps) => (
        <TextField
          {...inputProps}
          label={capitalize(t("assets:trailer.one", "Tractor"))}
          name="trailer"
          inputProps={{
            ...inputProps.inputProps,
            "data-testid": dataTestId ? `${dataTestId}-input` : undefined,
          }}
        />
      )}
      {...props}
    />
  );
}
